<template>
  <div class="master-supplier-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i>
              <strong v-if="item.new">{{ $t('create') }}</strong>
              <strong v-else>{{ $t('edit') }}</strong>
              <div class="card-actions">
              </div>
            </div>
            <b-form class="row">
              <b-col cols="9" align-self="center">
                <b-form-group v-bind:label="$t('material_detail')" :label-cols="3" :horizontal="true">
                  <v-select v-if="item.new" v-model="item.material_detail_id" :options="material_details">
                  </v-select>
                  <v-select v-else v-model="item.material_detail_id" :options="material_details" disabled>
                  </v-select>
                </b-form-group>
                <b-form-group v-bind:label="$t('supplier')" :label-cols="3" :horizontal="true">
                  <v-select multiple="multiple" v-model="item.supplier_ids" :options="suppliers">
                  </v-select>
                </b-form-group>
                <b-form-group v-bind:label="$t('active')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}"
                            v-model="item.is_active" v-bind:checked="item.is_active" :value="1" :uncheckedValue="0"/>
                </b-form-group>
              </b-col>
            </b-form>
            <div slot="footer" class="text-center">
              <router-link :to="{name: model + '_list'}">
                <b-button variant="default"><i class="fa fa-arrow-left"></i> {{$t('back')}}</b-button>
              </router-link>
<!--              <b-button variant="success" v-on:click="updateItem" v-if="material_detail_id != null && $auth.check(model + '.update')"><i-->
              <b-button variant="success" v-on:click="updateItem" v-if="material_detail_id != null"><i
                class="fa fa-save"></i> {{$t('update')}}
              </b-button>
<!--                <b-button variant="success" v-on:click="createItem" v-if="material_detail_id == null && $auth.check(model + '.create')"><i-->
              <b-button variant="success" v-on:click="createItem" v-if="material_detail_id == null"><i
                class="fa fa-save"></i> {{$t('save')}}
              </b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
  import cSwitch from '../../../../components/Switch'
  import {get, create, update} from '@/api/master_material_detail_supplier'
  import {getMasterMaterialDetail} from '@/api/master_material_detail'
  import {getMasterSupplierList} from '@/api/master_supplier'

  export default {
    name: 'MasterMaterialDetailSupplier',
    props: {
      material_detail_id: {
        type: String,
        default: null
      }
    },
    components: {
      cSwitch
    },
    computed: {},
    data: function () {
      return {
        model: 'master_material_detail_supplier',
        item: {
          new: true,
          material_detail_id: null,
          supplier_ids: '',
          is_active: 1
        },
        languages: Object.keys(this.$i18n.messages),
        material_details: [],
        suppliers: []
      }
    },
    methods: {
      /**
       * Get List Material Detail
       */
      getListMaterialDetail() {
        this.$Progress.start()
        getMasterMaterialDetail().then((response) => {
          for (let i in response.data.data) {
            this.material_details.push({
              label: response.data.data[i].code + ' - ' + response.data.data[i].name,
              value: response.data.data[i].id
            })
          }
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },
      /**
       * Get List Supplier
       */
      getListSupplier() {
        this.$Progress.start()
        getMasterSupplierList().then((response) => {
          for (let i in response.data.data) {
            this.suppliers.push({
              label: response.data.data[i].code + ' - ' + response.data.data[i].name,
              value: response.data.data[i].id
            })
          }
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },
      /**
       * Get details of object
       */
      getDetail() {
        this.$Progress.start()
        let params = {
          material_detail_id: this.material_detail_id
        }
        get(params).then((response) => {
          this.item = response.data.data
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },
      /**
       * Update item info to server
       */
      updateItem() {
        this.$Progress.start()
        let param = {
          'material_detail_id' : this.item.material_detail_id.value,
          'supplier_ids'       : [],
          'is_active'          : this.item.is_active
        }
        for (let i in this.item.supplier_ids) {
          param.supplier_ids.push(this.item.supplier_ids[i].value)
        }
        update(param).then((response) => {
          this.$notify({
            title: this.$t('success'),
            text: response.data.message,
            type: 'success'
          })
          this.$router.push({name: this.model})
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },
      /**
       * Create item info to server
       */
      createItem() {
        this.$Progress.start()
        let param = {
          'material_detail_id' : this.item.material_detail_id.value,
          'is_active'          : this.item.is_active,
          'supplier_ids'       : []
        }
        for (let i in this.item.supplier_ids) {
          param.supplier_ids.push(this.item.supplier_ids[i].value)
        }
        create(param).then((response) => {
          this.$notify({
            title: this.$t('success'),
            text: response.data.message,
            type: 'success'
          })
          this.$router.push({name: this.model})
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      }
    },
    created: function () {
      this.getListMaterialDetail()
      this.getListSupplier()
      if (this.material_detail_id != null) {
        this.item.new = false
        this.getDetail()
      } else {
        this.item.material_detail_id = ''
      }
    },
    watch: {}
  }
</script>



// WEBPACK FOOTER //
// src/views/admin/inventory/master_material_detail_supplier/Form.vue